import { useForm } from 'react-hook-form'
import { FormObjectType, GiftReceiveFormItemsType } from 'src/types/react-hook-form'
import { useModal } from 'src/provider/ModalContextProvider'
import { serviceTermsQueryOption, useCustomQuery } from 'src/hooks/react-query/useCustomQuery.hook'
import { HyphenReplace, NumReplace, regExps } from 'src/utils/regExps_util'

const useGiftReceiveForm = () => {
  const { openModal } = useModal()
  const methods = useForm<GiftReceiveFormItemsType>({
    mode: 'onSubmit',
    defaultValues: {
      recipientPNumber: '',
      giftIdx: 0,
      termsAgree: false,
    },
  })
  const { setValue } = methods
  const { data: termsData } = useCustomQuery(serviceTermsQueryOption({ Type: 4 }))

  const pNumberOnChangeHandler = (event: { target: { value: string } }) => {
    setValue('recipientPNumber', NumReplace(event.target.value, 11), { shouldValidate: false })

    if (regExps.numReg.pattern.test(event.target.value) && event.target.value.length === 11)
      setValue('recipientPNumber', HyphenReplace(event.target.value))
  }

  const registerAttribute: Record<keyof GiftReceiveFormItemsType, Partial<FormObjectType>> = {
    recipientPNumber: {
      type: 'tel',
      tag: 'recipientPNumber',
      register_options: {
        required: '받는 분의 휴대폰 번호를 입력해주세요.',
        minLength: { value: 11, message: '받는 분의 휴대폰 번호를 정확히 입력해주세요.' },
        pattern: {
          value: /^010[-0-9]*$/,
          message: '받는 분의 휴대폰 번호를 정확히 입력해주세요.',
        },
        onChange: pNumberOnChangeHandler,
        inputmode: 'numeric',
      },
    },
    giftIdx: {
      tag: 'giftIdx',
      register_options: {
        inputmode: 'numeric',
      },
    },
    termsAgree: {
      tag: 'termsAgree',
      labelValue: '개인정보 수집 동의(필수)',
      register_options: { required: true },
      labelOnClick: () =>
        openModal({
          button: { submit: { t: '닫기' } },
          contents: { t: termsData?.Body?.Title, d: termsData?.Body?.Contents },
        }),
    },
  }

  return {
    methods,
    registerAttribute,
  }
}
export default useGiftReceiveForm
